<div class="modal-header hire-modal-header p-4">
  <div class="d-flex justify-content-between align-items-center text-defualt w-100">
    <span class="font-weight-600">
      Job Description
    </span>
    <div class="d-flex">
      <button data-testid="auto-app-hire-quick-search-button-1" id="quick-search-cancel" class="hire-btn-secondary mr-3" (click)="dismiss()">Cancel
      </button>
      <button data-testid="auto-app-hire-quick-search-button-2" id="quick-search-apply" class="hire-btn-primary" (click)="redirectToInsightsDetails()">Apply
      </button>
    </div>
  </div>
</div>
<div class="p-4">
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <p class="mb-1 font-weight-600 f-14">Boolean Search</p>
      <span class="f-12" role="button" *ngIf="hasValue(keywordInputControl.value)"
        (click)="clearIndividualFilter('booleansearch')" style="cursor:pointer;">Clear</span>
    </div>

    <textarea data-testid="auto-app-hire-quick-search-textarea-1" name="" id="" class="wc-form-control" rows="10" cols="10" [formControl]="keywordInputControl"
      placeholder="Keyword or boolean search using Job Title, Skills, Name, Company or Industry"
      (blur)="selectedItem($event, 'booleansearch', 'enter')"
      (keydown.enter)="selectedItem($event, 'booleansearch', 'enter')" (click)="isEditing = true"
      [ngClass]="{'save-input': !isEditing}"></textarea>
  </div>
  <div class="mb-3">
    <div class="d-flex justify-content-between mb-1">
      <label for="jobtitle" class="f-12 font-weight-500">Job Title</label>
      <span class="pointer f-12" *ngIf="hasValue(jobTitleControl.value)" (click)="clearIndividualFilter('jobtitle')"
        style="cursor:pointer;">Clear All</span>
    </div>
    <input data-testid="auto-app-hire-quick-search-input-1" type="text" name="jobtitle" id="jobtitle" class="wc-form-control" placeholder="Type here"
      [formControl]="jobTitleControl" [matAutocomplete]="jobtitle_auto" (input)="searchSuggestions($event, 'jobtitle')"
      (keyup.enter)="selectedItem($event, 'jobtitle', 'enter')">
    <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
      @for(jt of jobTitleList; track jt.value) {
      <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
        [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
        <span class="d-flex align-items-center">
          <span class="text-truncate">{{jt.value
            | titlecase}}</span>
        </span>
      </mat-option>
      }
    </mat-autocomplete>
    <app-custom-chip *ngIf="jobTitleSelectedList?.length" [chips]="jobTitleSelectedList" [removable]="true"
      [showExclude]="true" (removed)="removeChip($event, 'jobtitle')" (excluded)="excludeChip($event, 'jobtitle')"
      class="mb-2 d-block">
    </app-custom-chip>
    <app-hire-suggestions-list [suggestions]="fieldSuggestions?.jobtitle"
      [showAiLabel]="showAiSuggestionsFor('jobtitle')"
      (suggestionAdded)="selectedItem($event, 'jobtitle', 'aisuggestion')">
    </app-hire-suggestions-list>
  </div>
  <div class="mb-3">
    <div class="d-flex justify-content-between mb-1">
      <label for="skills" class="f-12 font-weight-500">Skills</label>
      <span class="pointer f-12" *ngIf="hasValue(skillsControl.value)" (click)="clearIndividualFilter('skills')"
        style="cursor:pointer;">Clear All</span>
    </div>
    <input data-testid="auto-app-hire-quick-search-input-2" type="text" name="skills" id="skills" class="wc-form-control" placeholder="Type here"
      [formControl]="skillsControl" [matAutocomplete]="skills_auto" (input)="searchSuggestions($event, 'skills')"
      (keyup.enter)="selectedItem($event, 'skills', 'enter')" (click)="showAISuggestions('skills')">
    <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skills')">
      @for(jt of skillsList; track jt.value) {
      <mat-option [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase"
        [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
        <span class="d-flex align-items-center">
          <span class="text-truncate">{{jt.value
            | titlecase}}</span>
        </span>
      </mat-option>
      }
    </mat-autocomplete>
    <app-custom-chip *ngIf="skillsSelectedList?.length" [chips]="skillsSelectedList" [removable]="true"
      [showExclude]="true" [showMandatory]="true" (removed)="removeChip($event, 'skills')"
      (excluded)="excludeChip($event, 'skills')" (mandatory)="onMandatoryChip($event, 'skills')" class="mb-2 d-block">
    </app-custom-chip>
    <app-hire-suggestions-list [suggestions]="fieldSuggestions?.skills" [showAiLabel]="showAiSuggestionsFor('skills')"
      (suggestionAdded)="selectedItem($event, 'skills', 'aisuggestion')">
    </app-hire-suggestions-list>
  </div>
  <div class="">
    <label for="location" class="f-12 font-weight-500 mb-1">Location<i class="fa-regular fa-circle-info f-12 ml-1"
        *ngIf="(defaultContinents && (locationSelectedList?.length == 0 && locationContinents?.length == 0))"
        [ngbTooltip]="tooltipTemplate" placement="bottom"></i></label>
    <span class="pointer f-12" *ngIf="hasValue(locationControl.value)" (click)="clearIndividualFilter('location')"
      style="cursor:pointer;">Clear All</span>

    <ng-template #tooltipTemplate>
      Showing results for <b>{{ defaultContinents | titlecase }}</b>, add locations to search globally.
    </ng-template>
    <input data-testid="auto-app-hire-quick-search-input-3" type="text" name="location" id="location" class="wc-form-control" placeholder="Type here"
      [formControl]="locationControl" [matAutocomplete]="location_auto" (input)="searchSuggestions($event, 'location')"
      (click)="showAISuggestions('location')">
    <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
      @for(jt of locationList; track jt.value) {
      <mat-option
        [value]="{key: jt.value, doc_count: jt.doc_count, location_type: jt.location_type, continent: jt.location_continent}"
        [disabled]="isLocationDisabled(jt)">
        <span class="d-flex align-items-center tooltip-wrapper" [matTooltip]="getTooltipText(jt)"
          [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
          <span class="text-truncate">{{ jt.value | titlecase }}</span>
        </span>
      </mat-option>
      }
    </mat-autocomplete>
    <app-custom-chip *ngIf="locationSelectedList?.length" [chips]="locationSelectedList" [removable]="true"
      [showExclude]="true" (removed)="removeChip($event, 'location')" (excluded)="excludeChip($event, 'location')"
      class="mb-2 d-block">
    </app-custom-chip>
  </div>

</div>
